module.exports = __webpack_public_path__ + "static/media/urothelialcarcinoma.6c714a9f.svg";